import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Libs
import handleCopyValue from '@/methods/handleCopyValue'

// Components
import Button from '@/components/common/Button'
import Image from '@/components/common/Image'
import Icon from '@/assets/icons'

// Constants
import { WS_EVENT_LIVE_SHOW } from '@/constants/socketEvent'

// Types
import { RoomUserItemType } from '@/types/room'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

type HandUpItemProps = RoomUserItemType & {
  className?: string
  index: number
  isMicOn: boolean
  handleUserConnect: ({ uid }: { uid: string; name?: string }) => void
  handleUserDisconnect: ({ uid }: { uid: string }) => void
  handleConnectWaiting: ({ uid }: { uid: string }) => void
  setCurrentUid: any
}

const HandUpItem = (props: HandUpItemProps) => {
  const {
    className,
    index,
    name,
    type = 0,
    headshotUrl,
    uid = '',
    refCode,
    isMicOn,
    handleUserConnect,
    handleUserDisconnect,
    handleConnectWaiting,
    setCurrentUid,
  } = props

  const { t } = useTranslation()

  const isHandUp = type === WS_EVENT_LIVE_SHOW.handup
  const isConnecting = type === WS_EVENT_LIVE_SHOW.connect

  return (
    <div className={cx('item', className, { isMicOn })}>
      <p className={cx('item-index')}>{index + 1}</p>

      <div className={cx('item-image')}>
        {headshotUrl && <Image src={headshotUrl} width={40} height={40} style={{ objectFit: 'cover' }} alt='avatar' />}
      </div>

      <div className={cx('item-info')}>
        <p className={cx('item-info-name')}>{name}</p>
        <div className={cx('item-info-id')} onClick={() => handleCopyValue({ t, value: refCode })}>
          <div className={cx('item-info-id-text')}>ID | {refCode}</div>
          <div className={cx('item-info-id-icon')}>
            <Icon.Copy />
          </div>
        </div>
      </div>

      <div className={cx('item-action')}>
        {isHandUp && (
          <Button size='sm' onClick={() => handleUserConnect({ uid, name })}>
            {t('LiveRoom_Connect_Invite')}
          </Button>
        )}

        {isConnecting && !isMicOn && (
          <Button
            size='sm'
            isOutline
            onClick={() => {
              setCurrentUid(uid)
              handleConnectWaiting({ uid })
            }}
          >
            {t('LiveRoom_Connect_Waiting')}
          </Button>
        )}

        {isMicOn && (
          <div className={cx('item-action-close')} onClick={() => handleUserDisconnect({ uid })}>
            {t('LiveRoom_Connect_Cancel')}
          </div>
        )}
      </div>
    </div>
  )
}

export default HandUpItem
